import { render, staticRenderFns } from "./BaseStockProductLotScan.vue?vue&type=template&id=452bf777&scoped=true&"
import script from "./BaseStockProductLotScan.vue?vue&type=script&lang=js&"
export * from "./BaseStockProductLotScan.vue?vue&type=script&lang=js&"
import style0 from "./BaseStockProductLotScan.vue?vue&type=style&index=0&id=452bf777&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452bf777",
  null
  
)

export default component.exports